import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import FiltersModal from './components/FiltersModal';

import { Button } from '../../../utils/styledLibraryComponents';

import { FiltersContainer, IconActive } from './styledComponents';

function DeepsightFiltersButton(props) {
  const { readOnly, textFilterButton, advancedFilters, hasAppliedFilters } = props;

  const [filtersModalOpen, setFiltersModalOpen] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    if (
      !advancedFilters ||
      (advancedFilters && !advancedFilters.length) ||
      !advancedFilters.some((filter) => filter.display)
    ) {
      setIsFilterActive(false);
    }
  }, [advancedFilters]);

  /**
   * The indicator is only ever turned on from inside the modal, so it cannot survive a remount of
   * the button — the conditions would keep narrowing the list with nothing saying so. A page owning
   * the applied conditions can state it instead, and then it wins over the internal state.
   */
  const displayFilterActive = hasAppliedFilters ?? isFilterActive;

  return (
    <FiltersContainer>
      <Button
        color="inpulse-filter"
        fontSize={14}
        formatText={false}
        handleClick={() => {
          if (readOnly) {
            return;
          }

          setFiltersModalOpen(!filtersModalOpen);
        }}
        height={40}
        icon={'/images/inpulse/filter-black-small.svg'}
        isActive={filtersModalOpen}
        isDisabled={readOnly}
        label={textFilterButton}
        maxWidth={240}
        minWidth={240}
      />
      {displayFilterActive && (
        <IconActive
          alt="icon-filter-active"
          readOnly={readOnly}
          src={
            readOnly
              ? '/images/icon-dot-active-grey-inpulse.svg'
              : '/images/icon-dot-active-green-inpulse.svg'
          }
        />
      )}
      {filtersModalOpen && (
        <FiltersModal
          params={props}
          setFiltersModalOpen={setFiltersModalOpen}
          setIsFilterActive={setIsFilterActive}
        />
      )}
    </FiltersContainer>
  );
}

DeepsightFiltersButton.propTypes = {
  readOnly: PropTypes.bool,
  minWidth: PropTypes.number,
  textFilterButton: PropTypes.string.isRequired,
  // Left undefined, the indicator keeps being driven by the modal alone.
  hasAppliedFilters: PropTypes.bool,
};

DeepsightFiltersButton.defaultProps = {
  minWidth: 165,
  readOnly: false,
};

export default DeepsightFiltersButton;
